import { types } from 'mobx-state-tree';

export const MessagesParams = types
  .model('MessagesParams', {
    limit: types.optional(types.number, 20),
    offset: types.optional(types.number, 0),
  })
  .views((self) => ({
    //...
  }))
  .actions((self) => ({
    increaseOffset() {
      self.offset = self.offset + self.limit;
    },
    clearOffset() {
      self.offset = 0;
    },
    clearParams() {
      self.limit = 20;
      self.offset = 0;
    },
  }));
